// src/Sentences.js


import React, { useState, useEffect, useRef } from "react";

import './EnglishCBSE3.css';

const sentencesData = {
   
  "Fun with Friends-page no.1 & 2": {
    english: `
    Come dear hen, let us go to the village fair. 
    All right. Let me bring my chicks. 
    Come ducklings, let us go.
    We have reached the stream.
    I can not swim. How shall we cross the stream? I have a plan.
    `,
    telugu: "రా కోడి, మనం ఊరి సంతకి వెళ్దాం. సరే. నా కోడిపిల్లలను తీసుకువస్తాను. బాతు పిల్లలు రా, వెళ్దాం. మనం వాగు దగ్గరికి చేరుకున్నాం. నాకు ఈత రాదు. వాగును ఎలా దాటాలి? నా దగ్గర ఒక ప్లాన్ ఉంది.",
    hindi: "आओ प्यारी मुर्गी, चलो गाँव के मेले में चलते हैं। ठीक है। मुझे अपने चूजे लाने दो। आओ बत्तख के बच्चे, चलो चलते हैं। हम नदी के किनारे पहुँच गए हैं। मुझे तैरना नहीं आता। हम नदी कैसे पार करेंगे? मेरे पास एक योजना है।"
  },
  "Animals and Young ones- page no. 3": {
    english: `
    1) Duck -> Ducklings. 2)Hen -> Chick. 3)Cow -> Calf. 4) Cat -> Kitten.  5) Dog ->Puppy 
    
    `,
    telugu: "1) బాతు -> బాతు పిల్లలు. 2)కోడి -> కోడిపిల్ల. 3)ఆవు -> దూడ. 4) పిల్లి -> పిల్లి .5) కుక్క -> కుక్కపిల్ల.",
    hindi: "1) बत्तख -> बत्तख के बच्चे। 2) मुर्गी -> चूजा .3) गाय -> बछड़ा. 4) बिल्ली -> बिल्ली का बच्चा. 5) कुत्ता -> पिल्ला"
  },
  "Chapter-1:Colors- page no. 4": {
    english: `
    You have a few crayons, Red, yellow and blue. Green, Purple and black, I have some too.
    I need the red and you need the black. If we share our crayons, we have a full pack! 
    
    `,
    telugu: "మీ దగ్గర కొన్ని క్రేయాన్స్ ఉన్నాయి, ఎరుపు, పసుపు మరియు నీలం. ఆకుపచ్చ, ఊదా మరియు నలుపు, నా దగ్గర కూడా కొన్ని ఉన్నాయి.నాకు ఎరుపు కావాలి మరియు మీకు నలుపు కావాలి. మనం మన క్రేయాన్స్ పంచుకుంటే, మన దగ్గర పూర్తి ప్యాక్ ఉంటుంది!.",
    hindi: "आपके पास कुछ क्रेयॉन हैं, लाल, पीला और नीला। हरा, बैंगनी और काला, मेरे पास भी कुछ है। मुझे लाल चाहिए और आपको काला चाहिए। अगर हम अपने क्रेयॉन बाँट लें, तो हमारे पास पूरा पैक हो जाएगा!"
  },
  "Rearrange colors- page no. 6": {
    english: `
    1) LEBU-> BLUE. 2)LYLEWO -> YELLOW. 3)RENEG -> GREEN. 4) RUPPEL -> PURPEL.  5) NROBW ->BROWN 
    
    `,
    telugu: "1) LEBU-> BLUE. 2)LYLEWO -> YELLOW. 3)RENEG -> GREEN. 4) RUPPEL -> PURPEL.  5) NROBW ->BROWN .",
    hindi: "1) LEBU-> BLUE. 2)LYLEWO -> YELLOW. 3)RENEG -> GREEN. 4) RUPPEL -> PURPEL.  5) NROBW ->BROWN "
  },
  "Action words- page no. 7": {
    english: `
    what are the action words in this words => carrot, laugh, dance, leg, eat, cry, swim, potato, sleep, play, sun, dig, jump, run, book, face, write, cate, smile and push. 
    The action words are Laugh,Dance,Eat,Cry,Swim,Sleep,Play,Dig,Jump,Run,Write,Smile,Push
    `,
    telugu: "ఈ పదాలలోని యాక్షన్ పదాలు ఏమిటి => క్యారెట్, నవ్వు, నృత్యం, కాలు, తినండి, ఏడుపు, ఈత కొట్టండి, బంగాళాదుంప, నిద్ర, ఆడండి, సూర్యుడు, తవ్వండి, దూకు, పరిగెత్తండి, పుస్తకం, ముఖం, రాయండి, కేట్, చిరునవ్వు మరియు పుష్.యాక్షన్ పదాలు లాఫ్, డ్యాన్స్, ఈట్, క్రై, ఈత, నిద్ర, ఆడండి, తవ్వండి, దూకు, పరిగెత్తండి, రాయండి, చిరునవ్వు, నెట్టండి",
    hindi: "इस शब्द में क्रिया शब्द क्या हैं => गाजर, हँसना, नाचना, पैर, खाना, रोना, तैरना, आलू, सोना, खेलना, सूरज, खोदना, कूदना, दौड़ना, किताब, चेहरा, लिखना, काटना, मुस्कुराना और धक्का देना. क्रिया शब्द हैं हँसना, नाचना, खाना, रोना, तैरना, सोना, खेलना, खोदना, कूदना, दौड़ना, लिखना, मुस्कुराना, धक्का देना"
  },
  "Arrange colors in Alphabetical order- pageno. 13": {
    english: `
    Question: Yellow, Blue, Purple, Green and Red. Answer is Blue, Green, Purple, Red and Yellow. 
    
    `,
    telugu: "ప్రశ్న: పసుపు, నీలం, ఊదా, ఆకుపచ్చ మరియు ఎరుపు. సమాధానం నీలం, ఆకుపచ్చ, ఊదా, ఎరుపు మరియు పసుపు..",
    hindi: "प्रश्न: पीला, नीला, बैंगनी, हरा और लाल। उत्तर है नीला, हरा, बैंगनी, लाल और पीला।"
  },
  "Badal and Moti- pageno. 15": {
    english: `
    There was a boy called Badal. He lived with his mother in a village and they were very happy. One evening, when Badal was returning from school, he saw a puppy shivering in the cold. 
    
    `,
    telugu: "బాదల్ అనే అబ్బాయి ఉండేవాడు. అతను తన తల్లితో ఒక గ్రామంలో నివసించాడు మరియు వారు చాలా సంతోషంగా ఉన్నారు. ఒక సాయంత్రం, బాదల్ పాఠశాల నుండి తిరిగి వస్తుండగా, చలిలో వణుకుతున్న కుక్కపిల్లని చూశాడు.",
    hindi: "बादल नाम का एक लड़का था। वह अपनी माँ के साथ एक गाँव में रहता था और वे बहुत खुश थे। एक शाम, जब बादल स्कूल से लौट रहा था, तो उसने एक पिल्ला ठंड में काँपता हुआ देखा।"
  },
  "Badal- page no. 16": {
    english: `
    Badal brough him home. Can this puppy stay with us, Maa ? asked Badal. Yes beta, but only if you promise to take care of the puppy, said his mother with a smile. Badal and his mother named the puppy moti. As days went by, moti grew up and loved badal. They became best friends. They ate and played together. Moti followed badal wherever he went. They played their favourite games together.
    
    `,
    telugu: "బాదల్ అతన్ని ఇంటికి తీసుకొచ్చాడు. ఈ కుక్కపిల్ల మనతో ఉండగలదా మామా? అని బాదల్ అడిగాడు. అవును బేటా, కానీ నువ్వు కుక్కపిల్లని జాగ్రత్తగా చూసుకుంటానని మాట ఇస్తేనే అని అతని తల్లి నవ్వుతూ చెప్పింది. బాదల్ మరియు అతని తల్లి కుక్కపిల్లకి మోతి అని పేరు పెట్టారు. రోజులు గడిచేకొద్దీ, మోతి పెరిగి బాదల్‌ను ప్రేమించాడు. వారు ప్రాణ స్నేహితులు అయ్యారు. వారు కలిసి తిన్నారు, కలిసి ఆడుకున్నారు. మోతీ బాదల్ ఎక్కడికి వెళ్ళినా అతని వెంటే ఉన్నాడు. వారు తమకు ఇష్టమైన ఆటలను కలిసి ఆడుకున్నారు.",
    hindi: "बादल उसे घर ले आया। क्या यह पिल्ला हमारे साथ रह सकता है, माँ? बादल ने पूछा। हाँ बेटा, लेकिन तभी जब तुम इस पिल्ला की देखभाल करने का वादा करोगे, उसकी माँ ने मुस्कुराते हुए कहा। बादल और उसकी माँ ने पिल्ला का नाम मोती रखा। जैसे-जैसे दिन बीतते गए, मोती बड़ा होता गया और बादल से प्यार करने लगा। वे सबसे अच्छे दोस्त बन गए। वे साथ में खाते-पीते और खेलते थे। मोती बादल के साथ-साथ जाता था। वे साथ में अपने पसंदीदा खेल खेलते थे।"
  },
  "Badal- page no. 17": {
    english: `
    One rainy day, while Badal was on his way home from school, he slipped on the muddy lane and fell into a deep pit. He tried hard, but could not come out of the pit. Badal's mother was worried when he did not come home in time. Moti too was waiting at the gate. Badal's mother gathered the neighbours to help search for him. Moti too accompained them.
    
    `,
    telugu: "ఒక వర్షం పడుతున్న రోజు, బాదల్ పాఠశాల నుండి ఇంటికి వెళుతుండగా, బురద సందులో జారిపడి లోతైన గుంతలో పడిపోయాడు. అతను చాలా ప్రయత్నించాడు, కానీ గుంత నుండి బయటకు రాలేకపోయాడు. బాదల్ సమయానికి ఇంటికి రాకపోవడంతో అతని తల్లి ఆందోళన చెందింది. మోతీ కూడా గేటు వద్ద వేచి ఉంది. బాదల్ తల్లి అతని కోసం వెతకడానికి పొరుగువారిని సమీకరించింది. మోతీ కూడా వారితో పాటు వచ్చింది.",
    hindi: "एक बरसात के दिन, जब बादल स्कूल से घर लौट रहा था, कीचड़ भरी गली में फिसलकर गहरे गड्ढे में गिर गया। उसने बहुत कोशिश की, लेकिन गड्ढे से बाहर नहीं निकल सका। बादल की माँ को चिंता हुई जब वह समय पर घर नहीं आया। मोती भी गेट पर इंतज़ार कर रहा था। बादल की माँ ने उसे खोजने के लिए पड़ोसियों को इकट्ठा किया। मोती भी उनके साथ गया।"
  },
  "Badal-page no. 17-1": {
    english: `
    Moti caught Badal's scent. He followed the scent and went near the pit and started barking. This alerted the neighbours who were searching for badal. They used a rope to pull badal out of the pit. Everyone was relieved. Badal hugged and thanked Moti. 
    
    `,
    telugu: "మోతీ బాదల్ వాసనను గ్రహించాడు. అతను ఆ వాసనను అనుసరించి గుంట దగ్గరకు వెళ్లి మొరగడం ప్రారంభించాడు. ఇది బాదల్ కోసం వెతుకుతున్న పొరుగువారిని అప్రమత్తం చేసింది. వారు బాదల్‌ను గుంట నుండి బయటకు తీయడానికి ఒక తాడును ఉపయోగించారు. అందరూ ఉపశమనం పొందారు. బాదల్ మోతిని కౌగిలించుకుని కృతజ్ఞతలు తెలిపాడు.",
    hindi: "मोती को बादल की गंध आ गई। वह गंध का पीछा करते हुए गड्ढे के पास गया और भौंकने लगा। इससे बादल को खोज रहे पड़ोसियों को पता चल गया। उन्होंने बादल को गड्ढे से बाहर निकालने के लिए रस्सी का इस्तेमाल किया। सभी को राहत मिली। बादल ने मोती को गले लगाया और धन्यवाद दिया।"
  },
  "Badal Q&A- pageno. 18": {
    english: `
    1) What did Badal come across by the side of the road? Answer: Puppy.
    2) What did Badal and his mother name the puppy? Answer: Moti.
    3) What did badal fall into? Answer: Badal fell into a deep pit.
    4) How did moti find badal? Answer: Moti caught Badal's Scent. 
    
    `,
    telugu: "1) రోడ్డు పక్కన బాదల్ ఏమి చూశాడు? సమాధానం: కుక్కపిల్ల.2) బాదల్ మరియు అతని తల్లి ఆ కుక్కపిల్లకి ఏమి పేరు పెట్టారు? సమాధానం: మోతీ.3) బాదల్ దేనిలో పడ్డాడు? సమాధానం: బాదల్ లోతైన గుంతలో పడ్డాడు.4) మోతీ బాదల్‌ను ఎలా కనుగొన్నాడు? సమాధానం: మోతీ బాదల్ సువాసనను పట్టుకున్నాడు.",
    hindi: "1) बादल को सड़क के किनारे क्या मिला? उत्तर: पिल्ला।2) बादल और उसकी माँ ने पिल्ले का क्या नाम रखा? उत्तर: मोती।3) बादल किसमें गिर गया? उत्तर: बादल एक गहरे गड्ढे में गिर गया।4) मोती ने बादल को कैसे पाया? उत्तर: मोती ने बादल की गंध पकड़ी।"
  },
  "Make pairs with colors- page no. 20": {
    english: `
    1) Paper & pencil- yellow color. 2)Chair & table- blue color. 3)bat & ball- green color. 4) needle & thread- red color. 5) lock and key- brown color. 6) idli & sambar- pruple color. 
    
    `,
    telugu: "1) కాగితం & పెన్సిల్- పసుపు రంగు. 2) కుర్చీ & టేబుల్- నీలం రంగు. 3) బ్యాట్ & బంతి- ఆకుపచ్చ రంగు. 4) సూది & దారం- ఎరుపు రంగు. 5) లాక్ మరియు కీ- గోధుమ రంగు. 6) ఇడ్లీ & సాంబార్- ప్రూపుల్ రంగు.",
    hindi: "1) कागज और पेंसिल - पीला रंग। 2) कुर्सी और मेज - नीला रंग। 3) बल्ला और गेंद - हरा रंग। 4) सुई और धागा - लाल रंग। 5) ताला और चाबी - भूरा रंग। 6) इडली और सांभर - बैंगनी रंग।"
  },
  "Clues- page no. 21": {
    english: `
    Every day I wake up at 5 AM in the morning. Then I brush my teeth and go to wash room. After that, I take a bath and dress up for school. I do breakfast and I go to school. 
    
    `,
    telugu: "ప్రతిరోజు నేను ఉదయం 5 గంటలకు నిద్రలేస్తాను. తర్వాత పళ్ళు తోముకుని వాష్ రూమ్ కి వెళ్తాను. ఆ తర్వాత స్నానం చేసి స్కూల్ కి డ్రెస్ చేసుకుంటాను. బ్రేక్ ఫాస్ట్ చేసి స్కూల్ కి వెళ్తాను.",
    hindi: "मैं हर रोज़ सुबह 5 बजे उठता हूँ। फिर मैं अपने दाँत साफ करता हूँ और बाथरूम जाता हूँ। उसके बाद, मैं नहाता हूँ और स्कूल के लिए तैयार होता हूँ। मैं नाश्ता करता हूँ और स्कूल जाता हूँ।"
  },
  "Complete the story- page no. 22": {
    english: `
    A dove was resting on a branch of a tree near a stream. An ant fell into the stream and cried for help. The dove dropped a leaf into the stream. The ant climbed on the leaf and landed safely. Another day the ant saw a hunter aiming at the dove. She quickly climbed up and bit the hunter’s hand. The dove flew away unhurt.
    
    `,
    telugu: " ఒక పావురం ఒక వాగు దగ్గర చెట్టు కొమ్మపై విశ్రాంతి తీసుకుంటోంది. ఒక చీమ వాగులో పడి సహాయం కోసం కేకలు వేసింది. ఆ పావురం ఒక ఆకును ప్రవాహంలో వేసింది. ఆ చీమ ఆ ఆకుపై ఎక్కి సురక్షితంగా దిగింది. మరొక రోజు ఆ చీమ వేటగాడు పావురాన్ని లక్ష్యంగా చేసుకుని చూస్తుండటం చూసింది. అది త్వరగా పైకి ఎక్కి వేటగాడి చేతిని కరిచింది. పావురం గాయపడకుండా ఎగిరిపోయింది.",
    hindi: " एक कबूतर नदी के पास एक पेड़ की शाखा पर आराम कर रहा था। एक चींटी नदी में गिर गई और मदद के लिए चिल्लाई। कबूतर ने एक पत्ता नदी में गिरा दिया। चींटी उस पत्ते पर चढ़ गई और सुरक्षित रूप से उतर गई। एक और दिन चींटी ने एक शिकारी को कबूतर पर निशाना साधते देखा। वह जल्दी से ऊपर चढ़ गई और शिकारी के हाथ को काट लिया। कबूतर बिना किसी चोट के उड़ गया।"
  },

  "Best Friends-page no. 25": {
    english: `
    There were four friends- Circle, Square, Triangle and Rectangle. One day there began a fight between the friends. Each of them said they were the best. Circle said, I am the best! I am round and beautiful. I have no sharp edges. Children use me to draw a smiling face. There are so many beautiful things in my shape. I am the best.
    
    `,
    telugu: " నలుగురు స్నేహితులు ఉన్నారు - వృత్తం, చతురస్రం, త్రిభుజం మరియు దీర్ఘచతురస్రం. ఒక రోజు స్నేహితుల మధ్య గొడవ మొదలైంది. ప్రతి ఒక్కరూ తాము ఉత్తములమని అన్నారు. సర్కిల్ చెప్పింది, నేనే ఉత్తముడిని! నేను గుండ్రంగా మరియు అందంగా ఉన్నాను. నాకు పదునైన అంచులు లేవు. పిల్లలు నవ్వుతున్న ముఖాన్ని గీయడానికి నన్ను ఉపయోగిస్తారు. నా ఆకారంలో చాలా అందమైన విషయాలు ఉన్నాయి. నేనే ఉత్తముడిని. ",
    hindi: " चार दोस्त थे- वृत्त, वर्ग, त्रिभुज और आयत। एक दिन दोस्तों के बीच लड़ाई शुरू हो गई। उनमें से हर एक ने कहा कि वे सबसे अच्छे हैं। वृत्त ने कहा, मैं सबसे अच्छा हूँ! मैं गोल और सुंदर हूँ। मेरे पास कोई नुकीला किनारा नहीं है। बच्चे मेरा उपयोग मुस्कुराते हुए चेहरे को बनाने के लिए करते हैं। मेरे आकार में बहुत सारी सुंदर चीजें हैं। मैं सबसे अच्छा हूँ। "
  },
  "Best Friends-page no. 26": {
    english: `
    The other shapes refused to agree with the circle. Square then said, I am the best! I have four sides and all of them are equal in size. Children eat many sweets which are square in shape. I look very beautiful and so I am the best.
    
    `,
    telugu: " ఇతర ఆకారాలు వృత్తంతో ఏకీభవించడానికి నిరాకరించాయి. అప్పుడు చతురస్రం, నేనే అత్యుత్తముడిని! అని చెప్పింది! నాకు నాలుగు వైపులా ఉన్నాయి మరియు అవన్నీ పరిమాణంలో సమానంగా ఉంటాయి. పిల్లలు చతురస్రాకారంలో ఉన్న అనేక స్వీట్లను తింటారు. నేను చాలా అందంగా కనిపిస్తున్నాను మరియు అందుకే నేనే అత్యుత్తముడిని.",
    hindi: " अन्य आकृतियों ने वृत्त से सहमत होने से इनकार कर दिया। तब वर्ग ने कहा, मैं सर्वश्रेष्ठ हूँ! मेरे पास चार भुजाएँ हैं और वे सभी बराबर आकार की हैं। बच्चे बहुत सी मिठाइयाँ खाते हैं जो वर्गाकार आकार की होती हैं। मैं बहुत सुंदर दिखता हूँ और इसलिए मैं सर्वश्रेष्ठ हूँ।"
  },
  "Best Friends-page no. 26-1": {
    english: `
       After listening to this, Triangle said in a loud voice, I am the best! Just look at me! I am so beautiful. I have three sides. Children use me to draw mountains. They enjoy many yummy snacks in my shape. So, I am the best! 
    
    `,
    telugu: " ఇది విన్న తర్వాత, ట్రయాంగిల్ బిగ్గరగా, నేనే అత్యుత్తముడిని! నన్ను చూడు! నేను చాలా అందంగా ఉన్నాను. నాకు మూడు వైపులా ఉన్నాయి. పిల్లలు నన్ను ఉపయోగించి పర్వతాలను గీస్తారు. వారు నా ఆకారంలో చాలా రుచికరమైన చిరుతిళ్లను ఆస్వాదిస్తారు. కాబట్టి, నేనే అత్యుత్తముడిని! అని అన్నాడు.",
    hindi: " यह सुनकर त्रिभुज ने ऊँची आवाज़ में कहा, मैं सबसे अच्छा हूँ! बस मुझे देखो! मैं बहुत सुंदर हूँ। मेरी तीन भुजाएँ हैं। बच्चे पहाड़ बनाने के लिए मेरा इस्तेमाल करते हैं। वे मेरे आकार के कई स्वादिष्ट स्नैक्स का आनंद लेते हैं। इसलिए, मैं सबसे अच्छा हूँ!"
  },

  "Best Friends-page no. 27": {
    english: `
       Listening to the other three friends, Rectangle laughed aloud. Of course not. No one can be better than me. I have four sides. Two are equally long and two are equally short. I look so beautiful. Children enjoy biscuits and chocolates in rectangle shape. They also use so many things in my shape. I am the best! said the rectangle. 
    
    `,
    telugu: " మిగతా ముగ్గురు స్నేహితుల మాటలు వింటూ, రెక్టాంగిల్ బిగ్గరగా నవ్వింది. ఖచ్చితంగా కాదు. నాకంటే ఎవరూ బాగా ఉండలేరు. నాకు నాలుగు వైపులా ఉన్నాయి. రెండు సమానంగా పొడవుగా ఉంటాయి మరియు రెండు సమానంగా పొట్టిగా ఉంటాయి. నేను చాలా అందంగా కనిపిస్తున్నాను. పిల్లలు దీర్ఘచతురస్రాకారంలో బిస్కెట్లు మరియు చాక్లెట్లను ఇష్టపడతారు. వారు నా ఆకారంలో చాలా వస్తువులను కూడా ఉపయోగిస్తారు. నేనే ఉత్తముడిని! అని దీర్ఘచతురస్రం చెప్పింది.",
    hindi: " बाकी तीन दोस्तों की बात सुनकर आयत जोर से हंसने लगी। बिल्कुल नहीं। मुझसे बेहतर कोई नहीं हो सकता। मेरी चार भुजाएँ हैं। दो बराबर लंबी हैं और दो बराबर छोटी हैं। मैं बहुत सुंदर दिखती हूँ। बच्चे आयत के आकार में बिस्कुट और चॉकलेट का आनंद लेते हैं। वे मेरे आकार की बहुत सी चीजें भी इस्तेमाल करते हैं। मैं सबसे अच्छी हूँ! आयत ने कहा।"
  },
  "Best Friends-page no. 27-1": {
    english: `
       The friends could not decide who was the best among them. They decided to ask the first person they meet. After some time, they met a star. They stopped her and told her of their fight. They asked her to decide who was the best among them.
    
    `,
    telugu: " స్నేహితులు తమలో ఎవరు బెస్ట్ అని నిర్ణయించుకోలేకపోయారు. వారు మొదట కలిసే వ్యక్తిని అడగాలని నిర్ణయించుకున్నారు. కొంత సమయం తర్వాత, వారు ఒక స్టార్‌ను కలిశారు. వారు ఆమెను ఆపి, వారి పోరాటం గురించి చెప్పారు. తమలో ఎవరు బెస్ట్ అని నిర్ణయించుకోమని ఆమెను అడిగారు.",
    hindi: " दोस्त तय नहीं कर पा रहे थे कि उनमें से सबसे अच्छा कौन है। उन्होंने सबसे पहले मिलने वाले व्यक्ति से पूछने का फैसला किया। कुछ समय बाद, उन्हें एक सितारा मिला। उन्होंने उसे रोका और अपनी लड़ाई के बारे में बताया। उन्होंने उससे पूछा कि वह तय करे कि उनमें से सबसे अच्छा कौन है। "
  },
  "Best Friends-page no. 28": {
    english: `
       The star was wise. She looked at all of them. She thought for a while. Then she said, all of you are friends. Then why should you fight? Let me tell you something very important. Do you know what you could do if you were together? You could create the most beautiful pictures and patterns! Just look around. We find amazing designs and things  in all the shapes. So, stop fighting. Together we all can create wonders. The friends realized their mistake and promised each other that they would never fight again. They remained best friends forever.
    
    `,
    telugu: " ఆ నక్షత్రం తెలివైనది. ఆమె వారందరినీ చూసింది. ఆమె కాసేపు ఆలోచించింది. తర్వాత ఆమె, మీరందరూ స్నేహితులు. మరి మీరు ఎందుకు గొడవ పడాలి? చాలా ముఖ్యమైన విషయం నేను మీకు చెప్తాను. మీరు కలిసి ఉంటే మీరు ఏమి చేయగలరో మీకు తెలుసా? మీరు చాలా అందమైన చిత్రాలు మరియు నమూనాలను సృష్టించవచ్చు! చుట్టూ చూడండి. మేము అన్ని ఆకారాలలో అద్భుతమైన డిజైన్లు మరియు వస్తువులను కనుగొంటాము. కాబట్టి, పోరాటం ఆపండి. కలిసి మనమందరం అద్భుతాలను సృష్టించగలము. స్నేహితులు తమ తప్పును గ్రహించారు మరియు వారు ఇకపై ఎప్పటికీ గొడవ పడరని ఒకరికొకరు ప్రమాణం చేసుకున్నారు. వారు ఎప్పటికీ మంచి స్నేహితులుగా ఉన్నారు.",
    hindi: " तारा समझदार थी। उसने उन सभी को देखा। उसने कुछ देर सोचा। फिर उसने कहा, तुम सभी दोस्त हो। फिर तुम्हें क्यों लड़ना चाहिए? मैं तुम्हें एक बहुत ही महत्वपूर्ण बात बताती हूँ। क्या तुम जानते हो कि अगर तुम साथ होते तो क्या कर सकते थे? तुम सबसे सुंदर चित्र और पैटर्न बना सकते थे! बस चारों ओर देखो। हमें सभी आकृतियों में अद्भुत डिजाइन और चीजें मिलती हैं। इसलिए, लड़ना बंद करो। हम सभी एक साथ मिलकर चमत्कार कर सकते हैं। दोस्तों को अपनी गलती का एहसास हुआ और उन्होंने एक-दूसरे से वादा किया कि वे फिर कभी नहीं लड़ेंगे। वे हमेशा के लिए सबसे अच्छे दोस्त बने रहे। "
  },
  "Best Friends Q&A-page no. 29": {
    english: `
         1)who were the four friends? Answer: Circle, Square, Triangle and Rectangle. 2) why were they fighting? Answer: who is best. 3) who helped them to end their fight? Answer: Star. 4) what lesson did the friends learn in the end? Answer: Together can create wonders. 5) The circle does not have sharp edges. Answer: T. 6) A square has four sides but not all of them are equal in size. Answer: F. 7) The triangle has two sides. Answer: F. 8) The friends could decide who was the best among them. Answer: T.
    
    `,
    telugu: "1) ఆ నలుగురు స్నేహితులు ఎవరు? సమాధానం: వృత్తం, చతురస్రం, త్రిభుజం మరియు దీర్ఘచతురస్రం. 2) వారు ఎందుకు గొడవ పడ్డారు? సమాధానం: ఎవరు ఉత్తముడు. 3) వారి పోరాటాన్ని ముగించడానికి వారికి ఎవరు సహాయం చేసారు? సమాధానం: నక్షత్రం. 4) స్నేహితులు చివరికి ఏ పాఠం నేర్చుకున్నారు? సమాధానం: కలిసి ఉంటే అద్భుతాలు సృష్టించవచ్చు. 5) వృత్తానికి పదునైన అంచులు ఉండవు. సమాధానం: T. 6) ఒక చతురస్రానికి నాలుగు వైపులా ఉంటాయి కానీ అవన్నీ పరిమాణంలో సమానంగా ఉండవు. సమాధానం: F. 7) త్రిభుజానికి రెండు వైపులా ఉంటాయి. సమాధానం: F. 8) స్నేహితులు తమలో ఎవరు ఉత్తమమో నిర్ణయించుకోవచ్చు. సమాధానం: T.",
    hindi: " 1) चार दोस्त कौन थे? उत्तर: वृत्त, वर्ग, त्रिभुज और आयत। 2) वे क्यों लड़ रहे थे? उत्तर: सबसे अच्छा कौन है। 3) उनकी लड़ाई खत्म करने में किसने उनकी मदद की? उत्तर: तारा। 4) अंत में दोस्तों ने क्या सबक सीखा? उत्तर: साथ मिलकर चमत्कार कर सकते हैं। 5) वृत्त में नुकीले किनारे नहीं होते। उत्तर: टी। 6) एक वर्ग में चार भुजाएँ होती हैं, लेकिन उनमें से सभी बराबर आकार की नहीं होतीं। उत्तर: एफ। 7) त्रिभुज में दो भुजाएँ होती हैं। उत्तर: एफ। 8) दोस्त तय कर सकते थे कि उनमें से कौन सबसे अच्छा था। उत्तर: टी।"
  },
  "Best Friends Q&A-page no. 34 & 35": {
    english: `
        who are you? And what do you do? We are birds. We chirp and sing. Who are you? And what do you do? We are monkeys. We jump and swing. Who are you? And what do you do? We are dogs. We run and bark. Who are you? And what do you do? We are cats. We mew in the dark. Who are you? And what do you do? We are elephants. We raise our trunks. Who are you? And what do you do? We are lions. We roar and hunt.    
    `,
    telugu: " మీరు ఎవరు? మరియు మీరు ఏమి చేస్తారు? మేము పక్షులు. మేము కిచకిచలాడుతూ పాడతాము. మీరు ఎవరు? మరియు మీరు ఏమి చేస్తారు? మేము కోతులం. మేము దూకుతాము మరియు ఊగుతున్నాము. మీరు ఎవరు? మరియు మీరు ఏమి చేస్తారు? మేము కుక్కలు. మేము పరిగెత్తి మొరుగుతాము. మీరు ఎవరు? మరియు మీరు ఏమి చేస్తారు? మేము పిల్లులు. మేము చీకటిలో మెయిలింగ్ చేస్తాము. మీరు ఎవరు? మరియు మీరు ఏమి చేస్తారు? మేము ఏనుగులం. మేము మా తొండాలను పైకి లేపుతాము. మీరు ఎవరు? మరియు మీరు ఏమి చేస్తారు? మేము సింహాలు. మేము గర్జిస్తాము మరియు వేటాడతాము.",
    hindi: " तुम कौन हो? और तुम क्या करते हो? हम पक्षी हैं। हम चहचहाते हैं और गाते हैं। तुम कौन हो? और तुम क्या करते हो? हम बंदर हैं। हम कूदते हैं और झूलते हैं। तुम कौन हो? और तुम क्या करते हो? हम कुत्ते हैं। हम दौड़ते हैं और भौंकते हैं। तुम कौन हो? और तुम क्या करते हो? हम बिल्लियाँ हैं। हम अंधेरे में म्याऊँ-म्याऊँ करते हैं। तुम कौन हो? और तुम क्या करते हो? हम हाथी हैं। हम अपनी सूंड उठाते हैं। तुम कौन हो? और तुम क्या करते हो? हम शेर हैं। हम दहाड़ते हैं और शिकार करते हैं "
  },
"Out in the Garden-page no. 39 & 40": {
    english: `
        Out in the garden, each fine day. With my ball, I like to play. I bounce my ball, I throw my ball. I catch my ball, on each fine day. Out in the garden, Each fine day. With my kite, I like to play. I tug my kite, I pull my kite. I fly my kite, On each find day. Out in the garden, Each fine day. With my friends, I like to play. We run and skip, we jump and sway. We slide and swing, on each fine day.
    `,
    telugu: " తోటలో, ప్రతి మంచి రోజున. నా బంతితో, నేను ఆడటానికి ఇష్టపడతాను. నేను నా బంతిని ఎగురవేస్తాను, నా బంతిని విసురుతాను. ప్రతి మంచి రోజున నేను నా బంతిని పట్టుకుంటాను. తోటలో, ప్రతి మంచి రోజున. నా గాలిపటంతో, నేను ఆడటానికి ఇష్టపడతాను. నేను నా గాలిపటాన్ని లాగుతాను, నా గాలిపటాన్ని లాగుతాను. నేను నా గాలిపటాన్ని ఎగురవేస్తాను, ప్రతి దొరికిన రోజున. తోటలో, ప్రతి మంచి రోజున. నా స్నేహితులతో, నేను ఆడటానికి ఇష్టపడతాను. మేము పరిగెత్తుతాము, దాటవేస్తాము, దూకుతాము మరియు ఊగుతాము. ప్రతి మంచి రోజున మేము జారిపోతాము మరియు ఊగుతాము.",
    hindi: " बगीचे में, हर दिन। अपनी गेंद के साथ, मुझे खेलना पसंद है। मैं अपनी गेंद उछालता हूँ, मैं अपनी गेंद फेंकता हूँ। मैं अपनी गेंद को पकड़ता हूँ, हर दिन। बगीचे में, हर दिन। अपनी पतंग के साथ, मुझे खेलना पसंद है। मैं अपनी पतंग को खींचता हूँ, मैं अपनी पतंग को खींचता हूँ। मैं अपनी पतंग उड़ाता हूँ, हर दिन। बगीचे में, हर दिन। अपने दोस्तों के साथ, मुझे खेलना पसंद है। हम दौड़ते हैं और कूदते हैं, हम कूदते हैं और झूमते हैं। हम फिसलते हैं और झूलते हैं, हर दिन। "
  },

  "Animals and Young ones": {
    english: `
    1) Duck -> Ducklings. 2)Hen -> Chick. 3)Cow -> Calf. 4) Cat -> Kitten.  5) Dog ->Puppy 
    
    `,
    telugu: "",
    hindi: ""
  },
          
     
      
      
  // Add more sentences as needed
};


const EnglishCBSE3 = () => {
  const [selectedSentence, setSelectedSentence] = useState(""); // Default as empty
  const [voices, setVoices] = useState([]);
  const [speed, setSpeed] = useState(1); // Default voice speed

  useEffect(() => {
    const populateVoices = () => {
      const voicesList = window.speechSynthesis.getVoices();
      if (voicesList.length === 0) {
        // Retry fetching voices if not populated
        setTimeout(() => setVoices(window.speechSynthesis.getVoices()), 500);
      } else {
        setVoices(voicesList);
      }
    };

    populateVoices();
    window.speechSynthesis.addEventListener("voiceschanged", populateVoices);

    return () => {
      window.speechSynthesis.removeEventListener("voiceschanged", populateVoices);
    };
  }, []);

  const handleSentenceChange = (e) => {
    setSelectedSentence(e.target.value);
  };

  const handleReadAloud = (lang) => {
    if (!selectedSentence || !sentencesData[selectedSentence]) {
      alert("Please select a valid sentence.");
      return;
    }

    const sentence = sentencesData[selectedSentence][
      lang === "english" ? "english" : lang === "telugu" ? "telugu" : "hindi"
    ];
    if (!sentence) {
      alert(`No content found for ${lang}.`);
      return;
    }

    const utterance = new SpeechSynthesisUtterance(sentence);
    utterance.lang = getLangCode(lang);
    utterance.rate = speed; // Apply the selected speed

    const voice = voices.find((v) => v.lang === utterance.lang);
    if (voice) {
      utterance.voice = voice;
      window.speechSynthesis.speak(utterance);
    } else {
      alert(`No suitable voice found for ${lang}. Please check your system's voice support.`);
    }
  };

  const handleSpeedChange = (event) => {
    setSpeed(parseFloat(event.target.value)); // Update the speed state based on user input
  };

  const getLangCode = (lang) => {
    switch (lang) {
      case "english":
        return "en-US";
      case "telugu":
        return "te-IN";
      case "hindi":
        return "hi-IN";
      default:
        return "en-US";
    }
  };

  return (
    <div className="sentences">
      <h1>CBSE - English Class 3</h1>
      <div>
        <label>
          Select Sentence:
          <select value={selectedSentence} onChange={handleSentenceChange}>
            <option value="">--Select--</option>
            {Object.keys(sentencesData).map((sentence) => (
              <option key={sentence} value={sentence}>
                {sentence}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div>
        <label>
          Voice Speed:
          <input
            type="range"
            min="0.2"
            max="2"
            step="0.1"
            value={speed}
            onChange={handleSpeedChange}
          />
          <span>{speed.toFixed(1)}x</span> {/* Display current speed */}
        </label>
      </div>
      {selectedSentence && sentencesData[selectedSentence] && (
        <div className="translations">
          <div>
            <h2>Content: {sentencesData[selectedSentence].english || "Not available"}</h2>
            <button onClick={() => handleReadAloud("english")}>Read Aloud</button>
          </div>
          <div>
            <h2>Telugu: {sentencesData[selectedSentence].telugu || "Not available"}</h2>
            <button onClick={() => handleReadAloud("telugu")}>Read Aloud in Telugu</button>
          </div>
          <div>
            <h2>Hindi: {sentencesData[selectedSentence].hindi || "Not available"}</h2>
            <button onClick={() => handleReadAloud("hindi")}>Read Aloud in Hindi</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnglishCBSE3;
